import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

// Redirects unpaid users to /checkout when trying to access gated features.
// Admin users bypass. Users with has_paid=true pass through.
const PaywallGate = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-[#6B7A4F] border-t-transparent"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Admins bypass paywall
  if (user.role === 'admin') return children;

  // Redirect unpaid users to checkout
  if (!user.has_paid) {
    return <Navigate to="/checkout" replace />;
  }

  return children;
};

export default PaywallGate;
